import { render } from "./InfoPopup.vue?vue&type=template&id=80175f92&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"

import "./InfoPopup.vue?vue&type=style&index=0&id=80175f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80175f92"]])

export default __exports__